module.exports = __webpack_public_path__ + "img/logo-white.a32c1f1e.png";